import { Controller } from "stimulus"
import { isNativeApp, postToNative } from "../lib/native_bridge"

// Ticket 136: meldt de duo-status aan de native app-schil. 'switch' met een
// wissel-URL zodra er een partner is; 'scan' met de eigen hash zodat de app een
// 'scan partner'-knop kan tonen. Bij verlaten van de pagina: verbergen.
export default class extends Controller {
  static values = { mode: String, url: String, partner: String, ownHash: String }

  connect() {
    if (!isNativeApp()) return
    if (this.modeValue === "switch") {
      postToNative("duo", "show", { url: this.urlValue, partner: this.partnerValue })
    } else if (this.modeValue === "scan") {
      postToNative("duo", "canScan", { ownHash: this.ownHashValue })
    } else if (this.modeValue === "hide") {
      // Ticket 1735: de Duo PT-pagina heeft beide sporters zelf in beeld en
      // wisselt zonder te laden; de native wisselknop is dan overbodig.
      postToNative("duo", "hide")
    }
  }

  disconnect() {
    if (isNativeApp()) postToNative("duo", "hide")
  }
}
